import cn from "classnames";
import { Accordion } from "react-accessible-accordion";
import { generateTimeString } from "utils/times/generateTimeString";
import { useIntl } from "react-intl";

import "./AccordionComponent.scss";
import { AccordionComponentItem } from "./AccordionComponentItem";

interface AccordionComponentProps {
  className?: string;
  branches?: boolean;
  data: {
    id?: number;
    title: string;
    description?: string | JSX.Element;
    content?: string | JSX.Element;
    icon?: string;
    key?: string;
    address?: string;
    phone?: string;
    working_time?: {
      monday: string[];
      tuesday: string[];
      wednesday: string[];
      thursday: string[];
      friday: string[];
      saturday: string[];
      sunday: string[];
      exceptions: string[];
    };
  }[];
  searchValue?: string;
}

export function AccordionComponent({
  className,
  branches,
  data,
  searchValue,
}: AccordionComponentProps) {
  const { formatMessage } = useIntl();

  return (
    <Accordion allowZeroExpanded className={cn(className, "accordion")}>
      {data?.map((item) => {
        const shouldRenderBranch =
          item?.title?.toLowerCase().includes((searchValue || "").toLowerCase()) && branches;

        const translatedWorkingHours =
          item?.working_time && generateTimeString(item.working_time, formatMessage);

        if (item?.title && !branches) {
          return (
            <AccordionComponentItem
              question={item?.title}
              answer={item?.description || item?.content || ""}
              icon={item?.icon}
              key={item?.key || item?.id}
              categoryId={item?.id?.toString()}
              searchValue={searchValue}
            />
          );
        }

        if (shouldRenderBranch) {
          return (
            <AccordionComponentItem
              question={item?.title}
              answer={
                <div className="accordion__item__branches">
                  <div className="accordion__item__branches__section">
                    <h4 className="accordion__item__branches__section_heading">
                      მისამართი:
                    </h4>
                    <span>{item?.address}</span>
                  </div>
                  <div className="accordion__item__branches__section">
                    <h4 className="accordion__item__branches__section_heading">
                      ტელეფონი:
                    </h4>
                    <span>{item?.phone}</span>
                  </div>
                  <div className="accordion__item__branches__section">
                    <h4 className="accordion__item__branches__section_heading">
                      {formatMessage({
                        id: "branches.working-hours",
                        defaultMessage: "სამუშაო საათები",
                      })}
                      :
                    </h4>
                    <div className="accordion__item__branches__section_time">
                      {translatedWorkingHours &&
                        translatedWorkingHours.split(" &nbsp; ").map((time, i, arr) => (
                          <div key={i}>
                            {time}
                            {i < arr.length - 1 ? "," : ""}
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              }
              icon={item?.icon}
              key={item?.key || item?.id}
            />
          );
        }

        return null;
      })}
    </Accordion>
  );
}
